import { Switch, withStyles } from '@material-ui/core';
// https://github.com/mui-org/material-ui/blob/master/packages/material-ui/src/Switch/Switch.js
const CustomSwitch = withStyles({
    colorSecondary: {
        "&.Mui-checked + .MuiSwitch-track": {
            backgroundColor: "#1DD317"
        }
    },
    switchBase: {
        color: "red",
        '&$checked': {
            color: "#1DD317",
        },
        '&$checked + $track': {
            backgroundColor: "#1DD317",
        },
    },
    checked: {},
    track: {
        backgroundColor: "red"
    },

})(Switch);

export default CustomSwitch